import type { ClinicalQualityScore } from '@cartwheel/api/v1'
import { qualityScoreReportPath } from './clinical-quality-score-display'

interface Props {
  scores: ClinicalQualityScore[]
}

const RECOMMENDATION_LABELS: Record<string, string> = {
  no_action: 'No Action',
  written_feedback_coaching: 'Written Feedback + Coaching',
  escalate: 'Escalate',
}

function getScoreColor(percentage: number): string {
  if (percentage >= 88.89) return 'text-forest-light'
  if (percentage >= 66.67) return 'text-blue-600'
  return 'text-orange'
}

function getBarColor(percentage: number): string {
  if (percentage >= 88.89) return 'bg-forest-light'
  if (percentage >= 66.67) return 'bg-blue-500'
  return 'bg-orange'
}

export function ClinicalQualityScoreHistory({ scores }: Props) {
  if (scores.length === 0) return null

  return (
    <div className="divide-y divide-gray-stroke border border-gray-stroke rounded-lg overflow-hidden">
      {scores.map((score) => (
        <div key={score.id} className="flex items-center gap-3 px-4 py-3 bg-white hover:bg-gray-50">
          <div className={`text-base font-bold shrink-0 w-12 ${getScoreColor(score.percentage)}`}>
            {score.percentage.toFixed(0)}%
          </div>
          <div className="flex-1 min-w-0">
            <div className="w-full bg-gray-stroke rounded-full h-1.5">
              <div
                className={`h-1.5 rounded-full ${getBarColor(score.percentage)}`}
                style={{ width: `${Math.min(score.percentage, 100)}%` }}
              />
            </div>
          </div>
          {RECOMMENDATION_LABELS[score.recommendation] && (
            <span className="text-xs text-charcoal-50 shrink-0">
              {RECOMMENDATION_LABELS[score.recommendation]}
            </span>
          )}
          <span className="text-xs text-charcoal-50 shrink-0">
            {new Date(score.created_at).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })}
          </span>
          <a
            href={qualityScoreReportPath(score.id)}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 text-xs text-indigo hover:underline flex items-center gap-1"
          >
            <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
            Open
          </a>
        </div>
      ))}
    </div>
  )
}
